import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeMusicToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeMusicToYoutubeMusic}
            sections={<PairTransferGuideContent sourceKey="youtubeMusic" destKey="youtubeMusic" />}
        />
    );
}
